import {
  HydratedCanvas,
  useDeleteCanvas as useDeleteCanvasMutation,
  useFavoriteAssets,
} from "@zapier/client";
import { AssetTypes, useNotification } from "@zapier/utils";
import { useTranslations } from "@zapier/i18n";

interface Input {
  canvas: HydratedCanvas | undefined;
  folderId?: string;
}

export function useDeleteCanvas({ canvas, folderId }: Input) {
  const { mutate, isPending } = useDeleteCanvasMutation({ folderId });
  const { createNotification } = useNotification();
  const t = useTranslations("canvas-delete-modal");

  const { removeFromFavorites } = useFavoriteAssets();

  const deleteCanvas = () => {
    if (!canvas) {
      return;
    }

    mutate(
      { id: canvas.id },
      {
        onSuccess: () => {
          createNotification({
            message: t("notifications.delete-success", {
              canvasName: canvas.name || "",
            }),
            type: "success",
          });

          removeFromFavorites(canvas.id, AssetTypes.Canvas);
        },
        onError: () => {
          createNotification({
            message: t("notifications.delete-error", {
              canvasName: canvas.name || "",
            }),
            type: "error",
          });
        },
      },
    );
  };

  return { deleteCanvas, isPending };
}
